import { TWorkflowDefinition } from '@commenda/types';
import { TBuilderSelection } from '../components/WorkflowEditor/types';
import { TSelectedEntity } from '../types/node';

/** The one selected node, resolved against the definition so a name is never reported for a step that
 *  has since been deleted. Edges are ignored and not counted: a transition has no name worth reporting
 *  until transitions get labels. Shared by both callers so the two can never drift. */
export function resolveBuilderSelection(
  selectedEntities: TSelectedEntity[],
  workflow: TWorkflowDefinition | null
): TBuilderSelection | null {
  const nodes = selectedEntities.filter(
    (entity) => entity.type === 'node' || entity.type === 'trigger'
  );
  const [first] = nodes;
  if (!first) return null;

  const step = workflow?.steps.find((candidate) => candidate.id === first.id);
  if (!step) return null;

  return {
    id: step.id,
    stepType: String(step.type),
    name: step.name ?? '',
    otherSelectedCount: Math.max(nodes.length - 1, 0),
  };
}
